import React from 'react';
import { Globe, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-hero text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-white/10 p-2 rounded-lg">
                <Globe className="h-6 w-6" />
              </div>
              <div>
                <div className="text-xl font-bold font-['Space_Grotesk']">VISA INTELLIGENCE LTD</div>
                <div className="text-sm text-white/80">Immigration Experts</div>
              </div>
            </div>
            <p className="text-white/80 leading-relaxed mb-4 max-w-md">
              Your trusted partner for visa and immigration services. We provide expert consultation 
              and comprehensive document preparation to make your visa journey seamless.
            </p>
            <div className="space-y-2 text-sm text-white/70">
              <p>Company Number: 14304138</p>
              <p>Incorporated: 18 August 2022</p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-white/80">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="hover:text-white transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('why-us')}
                  className="hover:text-white transition-colors"
                >
                  Why Choose Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('process')}
                  className="hover:text-white transition-colors"
                >
                  Our Process
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('testimonials')}
                  className="hover:text-white transition-colors"
                >
                  Testimonials
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="hover:text-white transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 flex-shrink-0 mt-0.5" />
                <a
                  href="mailto:info@cont-mx.com"
                  className="hover:text-white transition-colors"
                >
                  info@cont-mx.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 flex-shrink-0 mt-0.5" />
                <span className="text-sm">
                  257a Whitechapel Road<br />
                  London, England, E1 1DB<br />
                  United Kingdom
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="text-sm text-white/70 text-center sm:text-left">
              © {currentYear} VISA INTELLIGENCE LTD. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm text-white/70">
              <a href="https://cont-mx.com" className="hover:text-white transition-colors">
                cont-mx.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
